// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__18vq8","actions":"GroupTable_actions__10v7s","deleteModalFooter":"GroupTable_deleteModalFooter__2LDNk"};